var React = require('react');

function Sort (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.85714 9H5.11875C4.66875 9 4.28571 9.33516 4.28571 9.72891C4.28571 10.1227 4.66875 10.5 5.11875 10.5H6.83304C7.33125 10.5 7.71429 10.1648 7.71429 9.75C7.71429 9.33516 7.33125 9 6.85714 9ZM11.1429 1.5H0.833036C0.383839 1.5 0 1.83586 0 2.22891C0 2.62195 0.383839 3 0.833036 3H11.1188C11.617 3 12 2.66484 12 2.25C12 1.83516 11.617 1.5 11.1429 1.5Z","fill":"#0577AF","key":0}),React.createElement("path",{"opacity":"0.4","d":"M9.42913 5.25H2.54788C2.09868 5.25 1.71484 5.58516 1.71484 5.97891C1.71484 6.37266 2.09868 6.75 2.54788 6.75H9.40502C9.90324 6.75 10.2863 6.41484 10.2863 6C10.2863 5.58516 9.90324 5.25 9.42913 5.25Z","fill":"#0577AF","key":1})]);
}

Sort.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Sort;

Sort.default = Sort;
